module.exports = __webpack_public_path__ + "static/media/docDelete.ff48d027.svg";